var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIconStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0011 22.5337C17.0465 22.8737 16.9331 23.2363 16.6725 23.4743C16.5676 23.5794 16.4431 23.6628 16.306 23.7196C16.1689 23.7765 16.0219 23.8058 15.8735 23.8058C15.725 23.8058 15.5781 23.7765 15.441 23.7196C15.3039 23.6628 15.1793 23.5794 15.0745 23.4743L10.5298 18.9297C10.4063 18.8088 10.3123 18.661 10.2553 18.4978C10.1983 18.3347 10.1798 18.1605 10.2011 17.989V12.1863L4.77246 5.23902C4.58841 5.00275 4.50537 4.70324 4.54147 4.40594C4.57757 4.10863 4.72988 3.8377 4.96513 3.65235C5.18046 3.49368 5.41846 3.40302 5.66779 3.40302H21.5345C21.7838 3.40302 22.0218 3.49368 22.2371 3.65235C22.4724 3.8377 22.6247 4.10863 22.6608 4.40594C22.6969 4.70324 22.6138 5.00275 22.4298 5.23902L17.0011 12.1863V22.5337ZM7.97979 5.66968L12.4678 11.4043V17.6603L14.7345 19.927V11.393L19.2225 5.66968H7.97979Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconStudio);
export default __webpack_public_path__ + "static/media/filter-icon-studio.d47171373443cabb5a7c8cf5432c6dbb.svg";
export { ForwardRef as ReactComponent };